<template>
    <div style="padding-bottom: 2px;">
        <v-card :style="`border: ${IsDataDignosisTemplate ? '1px solid #ff3333' : '1px solid white'}; box-shadow: ${IsDataDignosisTemplate ? '1px 1px 5px 1px #ff3333' : ''}; margin-top: 10px`">
            <v-card-title style="font-weight: 700; color: #004d40; background-color: #eee;">
                Select Diagnostic Procedure
            </v-card-title>
            <v-card-subtitle style="color: #000; background-color: #eee;">
                Please select at least one diagnostic procedure below.
            </v-card-subtitle>
        </v-card>
        <div style="height: 15px; margin: 5px 0 10px 0;">
            <div v-if="IsDataDignosisTemplate" class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                        At least one diagnostic procedure is required
                    </div>
                </div>
            </div>
        </div>
        <v-row no-gutters>
            <v-col
                v-for="(item, index) in diagnostics"
                :key="index"
                cols="12"
            >
                <v-row no-gutters>
                    <v-col xs="12">
                        <v-checkbox
                            v-model="item.value"
                            color="#009688"
                            dense
                            @change="setDiagnostic(item)"
                        >
                            <template #label>
                                <span style="font-weight: 500; color: black;">{{ item.label }}</span>
                            </template>
                        </v-checkbox>
                        <div
                            v-if="item.label === 'Complete Blood Count'"
                            style="padding-left: 30px"
                        >
                            <v-expand-transition>
                                <v-checkbox
                                    v-if="item.value"
                                    v-model="options.isCbcWithPlatelets"
                                    dense
                                    color="#009688"
                                    label="With Platelet Count"
                                />
                            </v-expand-transition>
                        </div>
                        <div
                            v-if="item.label === 'Chest X-RAY'"
                            style="padding-left: 30px"
                        >
                            <v-expand-transition>
                                <div v-if="item.value">
                                    <v-radio-group v-model="options.selectedXray">
                                        <p style="color: #666;">
                                            Choose chest x-ray view:
                                        </p>
                                        <v-radio
                                            v-for="(itemOptions, indexOption) in options.xray"
                                            :key="indexOption"
                                            :label="itemOptions.label"
                                            :value="itemOptions.text"
                                            color="#009688"
                                            style="margin-bottom: 15px;"
                                        />
                                        <div style="display: inline-block; margin-left: 0; height: 15.5px; position: relative; width: 300px;">
                                            <v-radio
                                                style="width: 100px; display: inline-block;"
                                                :label="options.xrayOther.label"
                                                :value="options.xrayOther.status"
                                                color="#009688"
                                            />
                                            <v-text-field
                                                ref="xrayOther1"
                                                v-model.trim="options.xrayOther.value"
                                                clearable
                                                style="position: absolute; right: 0; top: -3px; width: 218px;"
                                                color="#009688"
                                                dense
                                                :rules="options.xrayOther.rule"
                                                placeholder="Specify chest x-ray view."
                                                class="italic-placeholder-field"
                                                @blur="handleBlurXrayOther"
                                            />
                                        </div>
                                    </v-radio-group>
                                </div>
                            </v-expand-transition>
                        </div>
                    </v-col>
                    <v-col xs="12">
                        <DiagPrice
                            style="margin: 0; padding: 0;"
                            :is-selected="item.value"
                            :value="item.price"
                            :item="item"
                            @input="updatePrice($event, index)"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters style="height: 45px;">
            <v-col cols="6" style="height: 45px;">
                <h1 :style="`font-size: 16px; margin: 13px 0 0 30px; ${isTotalAmountExceedLimit ? 'color: red' : 'color: #00000099'}`">
                    Total Amount:
                </h1>
            </v-col>
            <v-col cols="6" style="padding-left: 35px; height: 45px; position: relative;">
                <v-icon :disabled="!isSomeDataDiagnostics" :style="`display: inline-block; position: absolute; left: 0; top: 12px; ${isTotalAmountExceedLimit ? 'color: red' : 'color: #00000099'}`">
                    {{ mdiCurrencyPhp }}
                </v-icon>
                <v-card :disabled="!isSomeDataDiagnostics" :style="`display: inline-block; width: 100%; height: 45px; position: relative; border: ${isTotalAmountExceedLimit ? '1px solid #ff3333' : '1px solid white'}; box-shadow: ${isTotalAmountExceedLimit ? '1px 1px 5px 1px #ff3333' : ''}`">
                    <span style="font-size: 16px; position: absolute; left: 12px; top: 13px;">{{ totalAmount }}</span>
                </v-card>
                <div>
                    <div v-if="isTotalAmountExceedLimit" class="v-messages theme--light error--text">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                                Total amount should not exceed 2000.00 pesos
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <p></p>
    </div>
</template>

<script>
import { mdiCurrencyPhp } from '@mdi/js'
import DiagPrice from './DiagPrice.vue'

export default {
    components: {
        DiagPrice
    },
    props: ['data', 'triggerChangeColor', 'isAmountExceedLimit'],
    data: ()=>({
        mdiCurrencyPhp,
        options: {
            selectedXray: 'PA',
            isCbcWithPlatelets: false,
            xray: [
                { label: 'PA, or posteroanterior', text: 'PA' },
                { label: 'AP, or anteroposterior', text: 'AP' },
                { label: 'Lateral', text: 'LATERAL' },
                { label: 'Apicolordotic', text: 'APICOLORDOTIC' }
            ],
            xrayOther: {
                label: 'Other: ',
                value: null,
                status: false,
                rule: []
            }
        },
        isSomeDataDiagnostics: false,
        selectAllDiagnostics: false,
        diagnostics: [
            { label: 'Urinalysis', value: false, price: null },
            { label: 'Fecalysis', value: false, price: null },
            { label: 'Complete Blood Count', value: false, price: null },
            { label: 'Chest X-RAY', value: false, price: null }
        ]
    }),
    computed: {
        isTotalAmountExceedLimit() {
            return this.totalAmount > 2000
        },
        /**
         * Returns the total amount of selected diagnostics.
         */
        totalAmount() {
            const amount = this.diagnostics
                .filter(item => item.value === true)
                .reduce((sum, item) => {
                    return sum += Number(item.price)
                }, 0)
            if (!isNaN(amount)) {
                return this.roundUp(amount, 2)
            } else {
                return '0.00'
            }
        },
        /**
         * Returns the customized "Chest X-RAY - ${specific view}" string.
         */
        chestXRAY() {
            if (this.options.selectedXray === false) {
                if (this.options.xrayOther.value) {
                    return this.options.xrayOther.value.toUpperCase()
                } else {
                    return false
                }
            } else {
                return this.options.selectedXray
            }
        },
        /**
         * `triggerChangeColor` is called after submitting the form.
         * This will change the CSS styling for validation.
         */
        IsDataDignosisTemplate() {
            return this.triggerChangeColor && !this.isSomeDataDiagnostics
        }
    },
    watch: {
        isTotalAmountExceedLimit(newVal) {
            this.$emit('isAmountExceedLimitChange', newVal)
        },
        'options.isCbcWithPlatelets'(newVal) {
            this.$emit('saveDiagnostics', { diagnostics: this.diagnostics, options: `Chest X-RAY - ${this.chestXRAY}`, isCbcWithPlatelets: newVal })
        },
        'options.xrayOther.value'(newVal) {
            if (newVal !== null && String(newVal).trim().length > 0) {
                this.options.selectedXray = false
                // Get the value of the "specify" field and then emit immediately.
                const options = `Chest X-RAY - ${newVal ? newVal.toUpperCase() : ''}`
                this.$emit('saveDiagnostics', { diagnostics: this.diagnostics, options, isCbcWithPlatelets: this.options.isCbcWithPlatelets })
            } else {
                this.$nextTick(()=>{
                    this.options.xrayOther.rule = [v => !!v || 'This field is required']
                })
            }
        },
        'options.selectedXray'(newVal) {
            // When newVal is false (meaning "Other" is selected), focus
            // on the text field to specify the x-ray view.
            // When newVal is true, reset the "specify" field and reset its validation rule.
            if (newVal === false) {
                if (this.$refs) {
                    if (this.$refs.xrayOther1) {
                        this.$refs.xrayOther1[0].focus()
                    }
                }
                this.$nextTick(()=>{
                    this.options.xrayOther.rule = [v => !!v || 'This field is required']
                })
            } else {
                this.$nextTick(()=>{
                    this.options.xrayOther = { label: 'Other: ', status: false, rule: [] }
                })
            }

            // Prepare the text for "Chest X-RAY" before emitting.
            const xray = this.diagnostics.findIndex(item => item.label === 'Chest X-RAY')

            let test = 'Chest X-RAY'
            if (this.diagnostics[xray].value) {
                test = `${test} - ${this.options.selectedXray}`
                this.$emit('saveDiagnostics', { diagnostics: this.diagnostics, options: test, isCbcWithPlatelets: this.options.isCbcWithPlatelets })
            }
        },
        'diagnostics': {
            handler(newVal) {
                // Check if there are one or more selected diagnostics.
                // This is used in data validation when the `IsDataDignosisTemplate` computed property is triggered.  It
                // enables the CSS styling based on whether the diagnostics are valid or not.
                this.selectAllDiagnostics = newVal.every(item => item.value == true)
                const isSomeDiagnosticsDataSelected = newVal.some(item => item.value == true)

                this.isSomeDataDiagnostics = this.selectAllDiagnostics
                    ? this.selectAllDiagnostics
                    : isSomeDiagnosticsDataSelected

                // Update the variables.
                // Used to reset or prepare before emitting the values.
                newVal.forEach((element) => {
                    if (element.label === 'Complete Blood Count') {
                        if (!element.value && this.options.isCbcWithPlatelets) {
                            this.options.isCbcWithPlatelets = false
                        }
                    }
                    if (element.label === 'Chest X-RAY') {
                        if (!element.value) {
                            this.options.selectedXray = 'PA'
                            this.options.xrayOther = { label: 'Other: ', value: null, status: false }
                        }
                    }
                })
                this.$emit('saveDiagnostics', { diagnostics: newVal, options: `Chest X-RAY - ${this.chestXRAY}`, isCbcWithPlatelets: this.options.isCbcWithPlatelets })
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleBlurXrayOther(event) {
            const trimmed = String(event.target.value).trim()
            this.options.xrayOther.value = trimmed

            this.$nextTick(() => {
                if (this.options.xrayOther.value.length === 0) {
                    this.options.xrayOther.value = null
                }
            })
        },
        updatePrice(value, index) {
            this.diagnostics[index].price = value
        },
        setDiagnostic(item) {
            if (!item.value) {
                // When unchecking, clear the price
                item.price = null
            }
        },
        roundUp(num, precision) {
            precision = Math.pow(10, precision)
            return (Math.round(num * precision) / precision).toFixed(precision === 100 ? 2 : 0)
        }
    }
}
</script>

<style>
.italic-placeholder-field input::placeholder {
    font-style: italic;
}
</style>
